import {
  SAVE_SUBSTITUTES,
  ADD_SUBSTITUTE,
  ADD_NEW_SUBSTITUTE,
  CLEAR_NEW_SUBSTITUTE,
  REMOVE_SUBSTITUTES,
  RESET_SUBSTITUTES,
  UPDATE_SUBSTITUTES,
  FETCH_SUBSTITUTES,
  FETCH_SUBSTITUTES_START,
  FETCH_SUBSTITUTES_SUCCESS,
  FETCH_SUBSTITUTES_ERROR,
  POST_SUBSTITUTES,
  POST_SUBSTITUTES_START,
  POST_SUBSTITUTES_SUCCESS,
  POST_SUBSTITUTES_ERROR,
  PATCH_SUBSTITUTES,
  PATCH_SUBSTITUTES_START,
  PATCH_SUBSTITUTES_SUCCESS,
  PATCH_SUBSTITUTES_ERROR,
  DELETE_SUBSTITUTES,
  DELETE_SUBSTITUTES_START,
  DELETE_SUBSTITUTES_SUCCESS,
  DELETE_SUBSTITUTES_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const saveSubstitutes = () => ({ type: SAVE_SUBSTITUTES })
const resetSubstitutes = () => ({ type: RESET_SUBSTITUTES })
const removeSubstitutes = (username) => ({ type: REMOVE_SUBSTITUTES, username })
const clearNewSubstitute = () => ({ type: CLEAR_NEW_SUBSTITUTE })
const addSubstitute = (substitute) => ({ type: ADD_SUBSTITUTE, substitute })
const addNewSubstitute = (substitute) => ({ type: ADD_NEW_SUBSTITUTE, substitute })
const updateSubstitutes = (substitutes) => ({ type: UPDATE_SUBSTITUTES, substitutes })

const startFetchSubstitutes = buildAsyncAction(
  FETCH_SUBSTITUTES,
  FETCH_SUBSTITUTES_START,
  [FETCH_SUBSTITUTES_SUCCESS, FETCH_SUBSTITUTES_ERROR]
)
const fetchSubstitutes = () => ({ type: FETCH_SUBSTITUTES })
const fetchSubstitutesStart = () => ({ type: FETCH_SUBSTITUTES_START })
const fetchSubstitutesSuccess = () => ({ type: FETCH_SUBSTITUTES_SUCCESS })
const fetchSubstitutesError = (error) => ({ type: FETCH_SUBSTITUTES_ERROR, error })

const startPostSubstitutes = buildAsyncAction(
  POST_SUBSTITUTES,
  POST_SUBSTITUTES_START,
  [POST_SUBSTITUTES_SUCCESS, POST_SUBSTITUTES_ERROR]
)
const postSubstitutes = (substitute) => ({ type: POST_SUBSTITUTES, substitute })
const postSubstitutesStart = () => ({ type: POST_SUBSTITUTES_START })
const postSubstitutesSuccess = () => ({ type: POST_SUBSTITUTES_SUCCESS })
const postSubstitutesError = (error) => ({ type: POST_SUBSTITUTES_ERROR, error })

const startPatchSubstitutes = buildAsyncAction(
  PATCH_SUBSTITUTES,
  PATCH_SUBSTITUTES_START,
  [PATCH_SUBSTITUTES_SUCCESS, PATCH_SUBSTITUTES_ERROR]
)
const patchSubstitutes = (substitute) => ({ type: PATCH_SUBSTITUTES, substitute })
const patchSubstitutesStart = () => ({ type: PATCH_SUBSTITUTES_START })
const patchSubstitutesSuccess = () => ({ type: PATCH_SUBSTITUTES_SUCCESS })
const patchSubstitutesError = (error) => ({ type: PATCH_SUBSTITUTES_ERROR, error })

const startDeleteSubstitutes = buildAsyncAction(
  DELETE_SUBSTITUTES,
  DELETE_SUBSTITUTES_START,
  [DELETE_SUBSTITUTES_ERROR, DELETE_SUBSTITUTES_SUCCESS]
)
const deleteSubstitutes = (substitute) => ({ type: DELETE_SUBSTITUTES, substitute })
const deleteSubstitutesStart = () => ({ type: DELETE_SUBSTITUTES_START })
const deleteSubstitutesSuccess = () => ({ type: DELETE_SUBSTITUTES_SUCCESS })
const deleteSubstitutesError = (error) => ({ type: DELETE_SUBSTITUTES_ERROR, error })

export {
  saveSubstitutes,
  removeSubstitutes,
  resetSubstitutes,
  updateSubstitutes,
  startFetchSubstitutes,
  fetchSubstitutes,
  fetchSubstitutesStart,
  fetchSubstitutesSuccess,
  fetchSubstitutesError,
  startPostSubstitutes,
  postSubstitutes,
  postSubstitutesStart,
  postSubstitutesSuccess,
  postSubstitutesError,
  startPatchSubstitutes,
  patchSubstitutes,
  patchSubstitutesStart,
  patchSubstitutesSuccess,
  patchSubstitutesError,
  clearNewSubstitute,
  addNewSubstitute,
  addSubstitute,
  startDeleteSubstitutes,
  deleteSubstitutes,
  deleteSubstitutesStart,
  deleteSubstitutesSuccess,
  deleteSubstitutesError,
}
